<!-- Item Administration -->
<section>


  <section *ngIf="gridSettings?.showGrid">
    <h3>All Items</h3>
    <kendo-grid [data]="itemGridDataResult"
                [height]="470"
                [sortable]="true"
                [navigable]="true"
                [filterable]="true"
                [groupable]="false"
                [reorderable]="true"
                [resizable]="false"
                [sort]="gridstate.sort"
                (sortChange)="itemGridSortChange($event)"
                [pageable]="{ buttonCount: 5, info: true }"
                [pageSize]="gridstate.take"
                [skip]="gridstate.skip"
                [columnMenu]="false"
                (pageChange)="itemGridPageChange($event)"
                (dataStateChange)="itemGridDataStateChange($event)"
                [filter]="gridstate.filter"
                [loading]="gridSettings.loading">
      <!--<ng-template kendoGridToolbarTemplate>
  <div class="k-grid-toolbar-button-display">-->
      <!--<button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
    Export To Excel
    <kendo-loader *ngIf="loadingExcel"></kendo-loader>
  </button>-->
      <!--<button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
        Export to PDF
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>
    </div>
  </ng-template>-->
      <kendo-grid-column field="longItemNumber" title="{{gridSettings?.label?.longItemNumber}}" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="shortDescription" title="{{gridSettings?.label?.shortDescription}}" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="basePrice" title="{{gridSettings?.label?.basePrice}}" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="description1" title="{{gridSettings?.label?.finishValue}}" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="size" title="{{gridSettings?.label?.size}}" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="isActive" title="{{gridSettings?.label?.isActive}}" [columnMenu]="false"
                         [filterable]="false" [editable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-switch [(ngModel)]="dataItem.isActive"
                        [onLabel]="'Yes'"
                        [offLabel]="'No'"
                        [disabled]="true">
          </kendo-switch>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="canPlaceOrder" title="CanPlaceOrder" [columnMenu]="false"
                         [filterable]="false" [editable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-switch [(ngModel)]="dataItem.canPlaceOrder"
                        [onLabel]="'Yes'"
                        [offLabel]="'No'"
                        [disabled]="true">
          </kendo-switch>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="{{gridSettings?.label?.actions}}" [width]="175" field="">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                  (click)="onEditItem(dataItem)">
            <span class=" k-icon k-i-edit k-i-pencil"></span>
          </button>
          <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
            <span class="k-icon k-i-trash">
            </span>
          </button>
          <br>

          <a href="javascript:void" class="link-cls" kendoButton (click)="toggleAssociateDialog(dataItem)">
            Associate/DeAssociate Item
          </a>
        </ng-template>
      </kendo-grid-command-column>

      <ng-template kendoGridNoRecordsTemplate>
      </ng-template>
      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
    <div class="col-sm-12">
      <div class="col-sm-6 center">
        <button [routerLink]="['/itemAdministration/addItem']" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
          Add Item
        </button>
      </div>
    </div>
  </section>

</section>
<section class="dialogSection">
  <kendo-dialog title="Associate Item" *ngIf="associateItem.opened" (close)="toggleAssociateDialog('')">
    <div class="row">
      <div class="col-sm-9">
        <kendo-autocomplete [suggest]="true"
                            [filterable]="true"
                            (filterChange)="handleItemFilter($event)"
                            (valueChange)="itemSelected($event)"
                            [(ngModel)]="selectedItemNumber"
                            name="selectedItemSuggestion"
                            [valueField]="'fullDescription'"
                            [loading]="itemsLoading"
                            [data]="filteredSuggestions"
                            [virtual]="{ itemHeight: 40 }"
                            [placeholder]="'e.g. 027660'"
                            highlightFirst="true"
                            class="w-100" [ngClass]="{'borderRed':associateItem.isEmptyItem && associateItem.isSubmitted}" (blur)="validateItemText()">
        </kendo-autocomplete>
      </div>
      <div class="col-sm-3 btn-alignment">
        <button class="m-3 clearKendoButton btn btn-success" kendoButton (click)="saveAssociateItem()">
          Associate
        </button>
      </div>
    </div>
    <br />
    <kendo-grid [data]="associateItemGridView"
                [height]="330"
                [sortable]="true"
                [navigable]="true"
                [filterable]="true"
                [groupable]="false"
                [reorderable]="true"
                [resizable]="false"
                [sort]="associateItemGridstate.sort"
                (sortChange)="associateItemGridSortChange($event)"
                [pageable]="{ buttonCount: 5, info: true }"
                [pageSize]="associateItemGridstate.take"
                [skip]="associateItemGridstate.skip"
                [columnMenu]="false"
                (pageChange)="associateItemGridPageChange($event)"
                (dataStateChange)="associateItemGridDataStateChange($event)"
                [filter]="associateItemGridstate.filter"
                [loading]="associateItemLoading">

      <kendo-grid-column field="associatedItemNumber" title="Item Number" [width]="120" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="associatedItemDescription" title="Item Description" [columnMenu]="false"
                         [filterable]="true" [editable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
            <kendo-filter-contains-operator></kendo-filter-contains-operator>
          </kendo-grid-string-filter-cell>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="Action" [width]="110" field="">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                  (click)="disassociateItem(dataItem)">
            <span class="k-icon k-i-close k-i-close"></span>
          </button>

        </ng-template>
      </kendo-grid-command-column>

      <ng-template kendoGridNoRecordsTemplate>
      </ng-template>
      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
    <div class="row">
      <div class="col-sm-12 float-left p-top">
        <label class="SuccessLbl" *ngIf="associateItem.isAssociateSuccess">
          {{associateItem.successMessageLbl}} &nbsp;<span class="k-icon k-i-check-circle k-i-checkmark-circle"
                                                          style="color:green;font-weight:600"></span>
        </label>
        <label class="errorLbl" *ngIf="associateItem.isAssociateError">{{associateItem.errorMessageLbl}}&nbsp;  <span class="k-icon k-i-cancel" style="color:red;font-weight:300"></span></label>

      </div>
    </div>
  </kendo-dialog>
</section>
<kendo-dialog title="Delete Item " *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    Are you sure you want to delete user
    <b> : {{ gridItemToRemove.longItemNumber }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      No
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
